module.exports = __webpack_public_path__ + "static/media/esign_intro_illustration_fisdom.f24455b2.svg";